<template>
    <v-autocomplete
        v-model="result"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        :disabled="!hasAllRoles(['DriverView'])"
        color="white"
        item-text="name"
        item-value="id"
        label="Start typing to search"
        placeholder="Start typing to search"
        outline
        single-line
        deletable-chips
        return-object
        clearable
    ></v-autocomplete>
</template>

<script>
import DriverApi from '@/api/DriversApi'

const driverApi = new DriverApi()

export default {
    name: 'DriverAutocomplete',
    data () {
        return {
            isLoading: false,
            items: [],
            entries: [],
            search: null
        }
    },
    props: {
        value: {
            type: [Object, null]
        },
        selected: {
            type: [Object, null]
        },
        role: {
            type: String,
            required: false,
            default: null
        },
        fleet: {
            type: [Object, null],
            required: false,
            default: null
        },
        vehicleId: {
            type: String,
            required: false
        },
        isFreeDriver: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {
        search: {
            handler: function (value, oldVal) {
                this.getDrivers(value)
            },
            deep: true
        },
        'fleet.id': function (id) {
            this.getDrivers()
        },
        deep: true
    },
    computed: {
        result: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    mounted () {
    },
    methods: {
        async getDrivers (value) {
            const response = await driverApi.getDrivers({
                name: value,
                fleetId: this.fleet ? this.fleet.id : null
            })
            let items = response.payload.items
            if (this.isFreeDriver) {
                let freeDrivers = items.filter(el => null == el.vehicle || el.vehicle.id === this.vehicleId)

                this.items = freeDrivers
                return
            }
            this.items = response.payload.items
        }
    }
}
</script>

<style scoped>

</style>
